export default __webpack_public_path__ + "static/media/G0780.34I-36930_-21728_0.1666269180000.32dc83fa.jpg";